"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MirBig = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MirBig = function MirBig(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 56,
    height: 28,
    viewBox: "0 0 56 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "MirBig_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 7,
    width: 15,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.013 7.16c.019.36.07.71.15 1.051.02.075.037.152.059.227l.026.092a6.018 6.018 0 005.737 4.205h7.947c.049-.273.08-.551.08-.838a4.723 4.723 0 00-1.542-3.49 4.72 4.72 0 00-3.197-1.248h-9.26z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#MirBig_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-14.518 34.984H67.59V-2.35h-82.108v37.333z",
    fill: "url(#MirBig_svg__MirBig_svg__paint0_linear_28002_71870)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.212 13.55v7.06h4.304v-3.976h4.332c2.262 0 4.192-1.283 4.938-3.085H38.212zm-7.628-4.97l-3.013 6.528h-.305V7.16h-4.28v13.452h3.632c.954 0 1.82-.554 2.22-1.421l3.013-6.527h.306v7.948h4.28V7.16h-3.632c-.954 0-1.821.555-2.22 1.421zm-19.93.347l1.783 6.18h.306l1.783-6.18a2.446 2.446 0 012.35-1.768h4.275v13.452h-4.28v-7.949h-.307l-2.446 7.95h-3.057l-2.446-7.95H8.31v7.95H4.03V7.158h4.274c1.09 0 2.048.721 2.35 1.768z",
    fill: "#064"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MirBig_svg__MirBig_svg__paint0_linear_28002_71870",
    x1: 38.013,
    y1: 9.947,
    x2: 52.011,
    y2: 9.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  }))));
};

exports.MirBig = MirBig;
var _default = MirBig;
exports.default = _default;